import clsx from 'clsx';
import React from 'react';
import { createStyles } from './styles';

export interface TextBlockProps {
  title: string;
  subtitle: string;
  size?: 'LARGE' | 'MEDIUM';
  className?: string;
  showBorder?: boolean;
}

const TextBlock = ({
  title,
  subtitle,
  size = 'LARGE',
  className = '',
  showBorder = true,
}: TextBlockProps): JSX.Element => {
  const classes = createStyles(size);

  return (
    <div className={clsx(showBorder && classes.titleSection, className)}>
      <h3 className={classes.title}>{title}</h3>
      <p className={classes.subtitle}>{subtitle}</p>
    </div>
  );
};

export default TextBlock;
